import React, { Component } from 'react'
import { database } from '../../firebase'
import { ref, child, get } from 'firebase/database'
import { withRouter } from '../../withRouter'
import Title from '../components/Title'
import RowView from '../modules/RowView'
import './View.css'

class View extends Component {
  constructor (props) {
    super(props)
    this.state = {
      rows: []
    }
    this.dbRef = ref(database, 'quinielas')
  }
  componentDidMount () {
    get(child(this.dbRef, 'modalidades'))
      .then((snap) => {
        if (snap.val()) {
          const rows = []
          snap.forEach((child) => {
            rows.push({
              id: child.key,
              active: child.val().active,
              titulo: child.val().titulo
            })
          })
          rows.sort((a, b) => {
            return a.titulo.localeCompare(b.titulo)
          })
          this.setState({
            rows: rows
          })
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }
  render () {
    return (
      <div className='view'>
        <Title title='Consultar quiniela' />
        <div className='view__content'>
          <div className='view__content__header'>
            <h3>Selecciona la modalidad de quiniela que quieres consultar</h3>
          </div>
          <div className='view__content__body'>
            {this.state.rows.map((row) => (
              <RowView
                {...row}
                key={row.id}
                history={this.props.history}
              />))}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(View)
